<portal-page design="none">
  <h2>{{ 'dashboard.label.welcome_title' | translate }}</h2>
  <div class="dashbar">
    @for (tiles of tilesByRows(); track tiles) {
      @for (tile of tiles; track tile.route; let tid = $index) {
        <div
          (click)="handleTileNavigation(tile)"
          [attr.aria-describedby]="'portal-dashboard-a11y-' + tid"
          [attr.aria-label]="tile.a11y | translate"
          class="dashbar-element"
          role="button"
          title="{{ tile.i18n | translate }}">
          <div
            [attr.aria-labelledby]="generateIds(tid, tile.subfeaturesmenu)"
            [id]="'portal-dashboard-a11y-' + tid"
            class="dashbar-element__label">
            {{ tile.i18n | translate }}
            @for (subfeature of tile.subfeaturesmenu; track subfeature.label; let sfid = $index) {
              <span
                [attr.aria-label]="subfeature.aria?.label | translate"
                [class]="subfeature.class"
                [eBeihilfeTileSubfeature]="subfeature.type"
                [id]="['portal-dashboard-a11y', tid, sfid].join('-')"
                title="{{ subfeature.label | translate }}"></span>
            }
          </div>
          <svg-icon [src]="tile.icon" [svgStyle]="{ 'width.px': 48 }" />
        </div>
      }
    }
  </div>
</portal-page>
